import { Component, OnInit, Input } from '@angular/core'
import { CompanyProfile } from '@model/company-profile/company-profile'
import { appConfig } from '@configuration/app-config'
import { ProfileTypeIdentifier } from '@enum/profile-type-identifier'

@Component({
  selector: 'app-credits-warning',
  templateUrl: './credits-warning.component.html',
  styleUrls: ['./credits-warning.component.scss']
})
export class CreditsWarningComponent implements OnInit {

  @Input()
  public is_edit: boolean = false

  @Input()
  public entity_type: 'ADVERT' | 'BLOG' | 'JOB'

  @Input()
  public company_profile: CompanyProfile = null

  @Input()
  public set profile_type(val: ProfileTypeIdentifier) {
    this._profile_type = val
    this.displayWarning()
  }
  public get profile_type(): ProfileTypeIdentifier {
    return this._profile_type
  }
  public _profile_type = ProfileTypeIdentifier.private

  public credits: number
  public message: string = null

  constructor() { }

  ngOnInit() {
    this.displayWarning()
  }

  displayWarning() {

    if (!this.company_profile) {
      return
    }

    if (!this.is_edit &&
      this.profile_type === ProfileTypeIdentifier.business &&
      (this.company_profile.type == "OTHER" || this.company_profile.type == 'CARPENTER_PLUS')
    ) {

      this.credits = appConfig.credits[this.entity_type]
      // the entity was made with a business profile and isn't an edit request
      if (this.company_profile.credits < appConfig.credits[this.entity_type]) {
        this.message = "WARNING"
      } else {
        this.message = "INFO"
      }
    }
  }
}
